import Analytics from '../analytics';
export const analytics = Analytics.event.builder().setPage('Common_Playlist');
